import { Navigation } from "@/components/Navigation";
import { HeroCarousel } from "@/components/HeroCarousel";
import { PracticeAreas } from "@/components/PracticeAreas";
import { MarqueeText } from "@/components/MarqueeText";
import { Founder } from "@/components/Founder";
import { News } from "@/components/News";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ScrollProgress } from "@/components/ScrollProgress";
import { HomeFAQ } from "@/components/HomeFAQ";
import { SEOHead } from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Sotsek Advocacia | Advogado Tributarista SP - Isenção IR e Revisão Tributária"
        description="Escritório de advocacia em São Paulo especializado em direito tributário. Isenção de IR para aposentados, revisão tributária, IPTU, ITBI e ISS. Atendimento 100% online em todo o Brasil."
        canonicalPath="/"
      />
      <ScrollProgress />
      <Navigation />
      <main>
        <HeroCarousel />
        <PracticeAreas />
        <MarqueeText />
        <HomeFAQ />
        <News />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
